<template>
	<div class="v5-x-dialog" @touchmove="lockScroll($event)">
		<transition name="v5-mask-fade" v-if="isMask">
			<div class="v5-x-dialog-mask" v-show="show" @click="clickMask"></div>
		</transition>
		<transition name="v5-x-dialog-fade">
			<div class="v5-x-dialog-content" v-show="show">
				<slot></slot>
			</div>
		</transition>
	</div>
</template>
<script>
	export default {
		name: 'v5-x-dialog',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			isMask: {
				type: Boolean,
				default: true
			},
			isLockScroll: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			value(val) {
				this.show = val;
			}
		},
		methods: {
			lockScroll(e) {
				if (this.isLockScroll) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
			clickMask() {
				this.$emit('on-click-mask');
			}
		},
		data() {
			return {
				show: this.value
			};
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>



// WEBPACK FOOTER //
// index.vue?4b7ee92a